import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BillingClient } from 'network/httpClients/BillingClient/BillingClient';
import { MUTATION_KEYS } from 'network/mutations/consts';
import { QUERY_KEYS } from 'network/queries/consts';

/**
 * Paid-cohort self-serve migration — the "Move".
 *
 * Calls POST /billing/v1/conversions/move with the selected `planSku` (credits;
 * the BE resolves it to a price id). The Move runs synchronously server-side, so
 * on success we invalidate account-info + quota to pull the now-migrated state —
 * the migration popup closes once the account reads as paid/self-serve.
 * @returns the mutation; call `.mutate(planSku)` to trigger the Move.
 */
export const useMigrateConversion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.MIGRATE_CONVERSION],
    mutationFn: (planSku: string) =>
      BillingClient.migrateConversion({ planSku }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.BILLING_ACCOUNT_INFO],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.BILLING_QUOTA_BALANCE],
      });
    },
  });
};
